export const formatCurrency = (amount?: number): string => {
  if (amount === undefined || amount === null) return 'A convenir';
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (date?: string): string => {
  if (!date) return '';
  return new Intl.DateTimeFormat('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
};

export const formatDateTime = (date?: string): string => {
  if (!date) return '';
  return new Intl.DateTimeFormat('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

export const formatRelativeTime = (date?: string): string => {
  if (!date) return '';
  const now = new Date();
  const then = new Date(date);
  const diffInSeconds = Math.floor((now.getTime() - then.getTime()) / 1000);

  if (diffInSeconds < 60) return 'Hace un momento';
  if (diffInSeconds < 3600) return `Hace ${Math.floor(diffInSeconds / 60)} min`;
  if (diffInSeconds < 86400) return `Hace ${Math.floor(diffInSeconds / 3600)} h`;
  if (diffInSeconds < 604800) return `Hace ${Math.floor(diffInSeconds / 86400)} d`;
  return formatDate(date);
};

export const getInitials = (name?: string): string => {
  if (!name) return '??';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    open: 'bg-primary-100 text-primary-700',
    in_progress: 'bg-warning-100 text-warning-700',
    completed: 'bg-success-100 text-success-700',
    cancelled: 'bg-secondary-100 text-secondary-600',
    pending: 'bg-warning-100 text-warning-700',
    accepted: 'bg-success-100 text-success-700',
    rejected: 'bg-danger-100 text-danger-700',
    active: 'bg-success-100 text-success-700',
    suspended: 'bg-danger-100 text-danger-700',
  };
  return colors[status] || 'bg-secondary-100 text-secondary-600';
};

export const getStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    open: 'Abierto',
    in_progress: 'En progreso',
    completed: 'Completado',
    cancelled: 'Cancelado',
    pending: 'Pendiente',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    withdrawn: 'Retirado',
    less_than_1_week: 'Menos de 1 semana',
    '1_to_2_weeks': '1 a 2 semanas',
    '2_to_4_weeks': '2 a 4 semanas',
    '1_to_3_months': '1 a 3 meses',
    more_than_3_months: 'Más de 3 meses',
  };
  return labels[status] || status;
};

export const truncateText = (text: string, maxLength: number = 100): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

export const generateSlug = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};
